import React, { useCallback, useState } from 'react'

import {
  NavigationBlockContext,
  NavigationBlockContextValue,
} from './navigationBlockContext'

/**
 * Provider for navigation blocking across the app
 * Manages the cancel dialog state when navigating away from upload page
 */
export const NavigationBlockProvider: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const [showCancelDialog, setShowCancelDialog] = useState(false)
  const [pendingNavigation, setPendingNavigation] = useState<string | null>(
    null
  )

  const triggerNavigationDialog = useCallback((targetPath: string) => {
    setPendingNavigation(targetPath)
    setShowCancelDialog(true)
  }, [])

  const confirmNavigation = useCallback(() => {
    setShowCancelDialog(false)
    setPendingNavigation(null)
  }, [])

  const cancelNavigation = useCallback(() => {
    setShowCancelDialog(false)
    setPendingNavigation(null)
  }, [])

  const value: NavigationBlockContextValue = React.useMemo(
    () => ({
      showCancelDialog,
      pendingNavigation,
      triggerNavigationDialog,
      confirmNavigation,
      cancelNavigation,
    }),
    [
      showCancelDialog,
      pendingNavigation,
      triggerNavigationDialog,
      confirmNavigation,
      cancelNavigation,
    ]
  )

  return (
    <NavigationBlockContext.Provider value={value}>
      {children}
    </NavigationBlockContext.Provider>
  )
}
